import { useEffect, useState } from "react";
import { NodeViewWrapper } from "@tiptap/react";
import { useNavigate } from "react-router-dom";
import { X, ArrowUpRight } from "lucide-react";
import { hentBlokkData, blokkSok, recordRute, fmtFrist, stageDot } from "./blokkData";

export default function EntitetBlokk({ node, updateAttributes, deleteNode, editor }) {
  const spec = node.attrs.spec || {};
  const [rad, setRad] = useState(null);
  const [sok, setSok] = useState("");
  const [treff, setTreff] = useState([]);
  const navigate = useNavigate();
  const specStr = JSON.stringify(spec);

  useEffect(() => {
    if (!spec.entityId) { setRad(null); return undefined; }
    let avbrutt = false;
    hentBlokkData({ ...spec, typ: "entitet" }, editor.dokId)
      .then((r) => { if (!avbrutt) setRad(r[0] || null); })
      .catch(() => { if (!avbrutt) setRad(null); });
    return () => { avbrutt = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [specStr]);

  useEffect(() => {
    if (spec.entityId) return undefined;
    const t = setTimeout(() => blokkSok(sok, "speakers,partners").then(setTreff).catch(() => setTreff([])), 200);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sok, spec.entityId]);

  if (!spec.entityId) {
    return (
      <NodeViewWrapper className="dok-blokk" data-testid="dok-blokk-entitet-velger">
        <div className="dok-blokk-hode" contentEditable={false}>
          <span className="dok-blokk-type">Record-kort</span>
          <span className="flex-1" />
          <button type="button" className="dok-blokk-knapp slett" onClick={deleteNode} title="Fjern"><X size={12} /></button>
        </div>
        <div contentEditable={false}>
          <input value={sok} onChange={(e) => setSok(e.target.value)} placeholder="Søk etter speaker eller partner …" autoFocus
            className="dok-blokk-input w-full" data-testid="dok-blokk-entitet-sok" />
          <div className="dok-blokk-treff">
            {treff.slice(0, 6).map((r) => (
              <button key={r.id} type="button" onClick={() => updateAttributes({ spec: { ...spec, kilde: r.kilde, entityId: r.id } })} data-testid={`dok-blokk-entitet-treff-${r.id}`}>
                <span className="truncate">{r.navn}</span>
                <span className="under truncate">{r.under || r.stageLabel}</span>
              </button>
            ))}
          </div>
        </div>
      </NodeViewWrapper>
    );
  }

  return (
    <NodeViewWrapper className="dok-blokk dok-blokk-entitetkort" data-testid={`dok-blokk-entitet-${spec.bid}`}>
      <div className="dok-blokk-hode" contentEditable={false}>
        <span className="dok-blokk-type">{spec.kilde === "partners" ? "Partner" : "Speaker"}</span>
        <span className="flex-1" />
        <button type="button" className="dok-blokk-knapp" onClick={() => updateAttributes({ spec: { ...spec, entityId: "" } })} title="Bytt record" data-testid={`dok-blokk-entitet-bytt-${spec.bid}`}>Bytt</button>
        <button type="button" className="dok-blokk-knapp slett" onClick={deleteNode} title="Fjern"><X size={12} /></button>
      </div>
      {rad ? (
        <button type="button" className="dok-blokk-entitetinnhold" onClick={() => navigate(recordRute(rad))} contentEditable={false} data-testid={`dok-blokk-entitet-aapne-${spec.bid}`}>
          <span className="min-w-0">
            <span className="navn block truncate">{rad.navn}</span>
            {rad.under && <span className="under block truncate">{rad.under}</span>}
            <span className="meta flex items-center gap-2 mt-1.5">
              <span className="dok-blokk-chip"><i className="dok-blokk-dot" style={{ background: stageDot(rad.stage) }} />{rad.stageLabel}</span>
              {rad.ansvarlig && <span>{rad.ansvarlig}</span>}
              {rad.frist && <span>Frist {fmtFrist(rad.frist)}</span>}
            </span>
          </span>
          <ArrowUpRight size={14} className="shrink-0 opacity-40" />
        </button>
      ) : (
        <p className="dok-blokk-tom">Henter …</p>
      )}
    </NodeViewWrapper>
  );
}
